import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import LinkButton from 'shared/components/vxl/LinkButton/LinkButton';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import HyperlinkXsText from 'shared/components/vxl/typography/primary/hyperlink/HyperlinkXSText';

import showMoreAccordianStrings from './ShowMoreAccordionStrings.en';

interface ShowMoreAccordianProps {
  text: string;
  maxLength: number;
}

export default function ShowMoreAccordian({
  text,
  maxLength,
}: ShowMoreAccordianProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t: translatedText } = useTranslation('showMoreAccordian', {
    keyPrefix: 'display',
  });

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const ellipses = '... ';

  const displayText = isExpanded ? text : text.slice(0, maxLength);
  const shouldTruncate = text.length > maxLength;

  const { display } = showMoreAccordianStrings;

  return (
    <View>
      <BodyXSText>
        {displayText}
        {!isExpanded && shouldTruncate ? (
          <>
            <BodyXSText>{ellipses}</BodyXSText>
            <HyperlinkXsText onPress={toggleExpanded}>
              {translatedText('seeMore', display.seeMore)}
            </HyperlinkXsText>
          </>
        ) : null}
      </BodyXSText>
      {isExpanded && shouldTruncate ? (
        <LinkButton
          linkOnPress={toggleExpanded}
          text={translatedText('seeLess', display.seeLess)}
          size="xSmall"
        />
      ) : null}
    </View>
  );
}
